import { APPCONFIG } from '../app.config';

export const APIS = {
    MODULO: 'ingresos-publicos',
    URLS: {
        LOGIN: APPCONFIG.SITE.WEBAPI_SEGURIDAD + 'api/login',
        SESION: APPCONFIG.SITE.WEBAPI_SEGURIDAD + 'api/sesion',
        USUARIO: APPCONFIG.SITE.WEBAPI_SEGURIDAD + 'api/usuario',
        AUTH_USUARIO: APPCONFIG.SITE.WEBAPI_SEGURIDAD + 'api/usuario',
        PERMISO: APPCONFIG.SITE.WEBAPI + 'api/permiso',
        FILE: APPCONFIG.SITE.WEBAPI + 'api/file',
        PROCESO: APPCONFIG.SITE.WEBAPI + 'api/proceso',
        REPORTE: APPCONFIG.SITE.WEBAPI + 'api/reporte',
        FIRMA_DIGITAL: APPCONFIG.SITE.WEBAPI + 'api/firma-digital',
        CONFIGURACION: APPCONFIG.SITE.WEBAPI + 'api/configuracion',
        LISTA: APPCONFIG.SITE.WEBAPI + 'api/lista',
        ENTIDAD: APPCONFIG.SITE.WEBAPI + 'api/entidad',
        INFORMACION_ADICIONAL: APPCONFIG.SITE.WEBAPI + 'api/informacion-adicional',
        ARCHIVO: APPCONFIG.SITE.WEBAPI + 'api/archivo',
        OBSERVACION: APPCONFIG.SITE.WEBAPI + 'api/observacion',
        ETIQUETA: APPCONFIG.SITE.WEBAPI + 'api/etiqueta',
        CUENTA: APPCONFIG.SITE.WEBAPI + 'api/cuenta',
        VINCULO_CUENTA: APPCONFIG.SITE.WEBAPI + 'api/vinculo-cuenta',
        CONTRIBUYENTE: APPCONFIG.SITE.WEBAPI + 'api/contribuyente',
        VARIABLE: APPCONFIG.SITE.WEBAPI + 'api/variable',
        VARIABLE_GLOBAL: APPCONFIG.SITE.WEBAPI + 'api/variable-global',
        VARIABLE_LISTA: APPCONFIG.SITE.WEBAPI + 'api/variable-lista',
        PERSONA: APPCONFIG.SITE.WEBAPI + 'api/persona',
        EXPEDIENTE: APPCONFIG.SITE.WEBAPI + 'api/expediente',
        MEDIO_PAGO: APPCONFIG.SITE.WEBAPI + 'api/medio-pago',
        INMUEBLE: APPCONFIG.SITE.WEBAPI + 'api/inmueble',
        CATASTRO: APPCONFIG.SITE.WEBAPI + 'api/catastro',
        COMERCIO: APPCONFIG.SITE.WEBAPI + 'api/comercio',
        VEHICULO: APPCONFIG.SITE.WEBAPI + 'api/vehiculo',
        CEMENTERIO: APPCONFIG.SITE.WEBAPI + 'api/cementerio',
        CEMENTERIO_UBICACION_DEFINICION: APPCONFIG.SITE.WEBAPI + 'api/cementerio-ubicacion-definicion',
        FONDEADERO: APPCONFIG.SITE.WEBAPI + 'api/fondeadero',
        ESPECIAL: APPCONFIG.SITE.WEBAPI + 'api/cuenta-especial',
        EMISION_DEFINICION: APPCONFIG.SITE.WEBAPI + 'api/emision-definicion',
        EMISION_EJECUCION: APPCONFIG.SITE.WEBAPI + 'api/emision-ejecucion',
        EMISION_EJECUCION_CUENTA: APPCONFIG.SITE.WEBAPI + 'api/emision-ejecucion-cuenta',
        EMISION_APROBACION: APPCONFIG.SITE.WEBAPI + 'api/emision-aprobacion',
        PROCEDIMIENTO: APPCONFIG.SITE.WEBAPI + 'api/procedimiento',
        TASA: APPCONFIG.SITE.WEBAPI + 'api/tasa',
        SUB_TASA: APPCONFIG.SITE.WEBAPI + 'api/sub-tasa',
        CERTIFICADO_ESCRIBANO: APPCONFIG.SITE.WEBAPI + 'api/certificado-escribano',
        CERTIFICADO_APREMIO: APPCONFIG.SITE.WEBAPI + 'api/certificado-apremio',
        APREMIO: APPCONFIG.SITE.WEBAPI + 'api/apremio',
        PLANTILLA_DOCUMENTO: APPCONFIG.SITE.WEBAPI + 'api/plantilla-documento',
        TIPO_RELACION_CERTIFICADO_APREMIO_PERSONA: APPCONFIG.SITE.WEBAPI + 'api/tipo-relacion-certificado-apremio-persona',
        TIPO_ACTO_PROCESAL: APPCONFIG.SITE.WEBAPI + 'api/tipo-acto-procesal',
        TIPO_ACCESORIO: APPCONFIG.SITE.WEBAPI + 'api/tipo-accesorio',
        ORGANO_JUDICIAL: APPCONFIG.SITE.WEBAPI + 'api/organo-judicial',
        CONTROLADOR: APPCONFIG.SITE.WEBAPI + 'api/controlador',
        CUENTA_CORRIENTE_ITEM: APPCONFIG.SITE.WEBAPI + 'api/cuenta-corriente-item',
        CUENTA_CORRIENTE_CONDICION_ESPECIAL: APPCONFIG.SITE.WEBAPI + 'api/cuenta-corriente-condicion-especial',
        CUENTA_PAGO: APPCONFIG.SITE.WEBAPI + 'api/cuenta-pago',
        BOLETA_EMISION: APPCONFIG.SITE.WEBAPI + 'api/boleta-emision',
        PLAN_PAGO_DEFINICION: APPCONFIG.SITE.WEBAPI + 'api/plan-pago-definicion',
        PLAN_PAGO: APPCONFIG.SITE.WEBAPI + 'api/plan-pago',
        PAGO_CONTADO_DEFINICION: APPCONFIG.SITE.WEBAPI + 'api/pago-contado-definicion',
        PAGO_CONTADO: APPCONFIG.SITE.WEBAPI + 'api/pago-contado',
        TIPO_PLAN_PAGO: APPCONFIG.SITE.WEBAPI + 'api/tipo-plan-pago',
        TIPO_VENCIMIENTO_PLAN_PAGO: APPCONFIG.SITE.WEBAPI + 'api/tipo-vencimiento-plan-pago',
        CONVENIO_PARAMETRO: APPCONFIG.SITE.WEBAPI + 'api/convenio-parametro',
        COLECCION: APPCONFIG.SITE.WEBAPI + 'api/coleccion',
        CUENTA_PRUEBA: APPCONFIG.SITE.WEBAPI + 'api/cuenta-prueba',
        RECIBO_ESPECIAL: APPCONFIG.SITE.WEBAPI + 'api/recibo-especial',
        TIPO_MULTA: APPCONFIG.SITE.WEBAPI + 'api/tipo-multa',
        IMPORTADOR: APPCONFIG.SITE.WEBAPI + 'api/importador',
        EXPORTADOR: APPCONFIG.SITE.WEBAPI + 'api/exportador',
        CALENDARIO: APPCONFIG.SITE.WEBAPI + 'api/calendario',
        MODELO_DECLARACION_JURADA: APPCONFIG.SITE.WEBAPI + 'api/modelo-declaracion-jurada',
        DECLARACION_JURADA: APPCONFIG.SITE.WEBAPI + 'api/declaracion-jurada',
        PERSONA_FISICA: APPCONFIG.SITE.WEBAPI_ADMINISTRACION + 'api/persona-fisica',
        PERSONA_JURIDICA: APPCONFIG.SITE.WEBAPI_ADMINISTRACION + 'api/persona-juridica',
        CLASE_ELEMENTO: APPCONFIG.SITE.WEBAPI + 'api/clase-elemento',
        TIPO_ELEMENTO: APPCONFIG.SITE.WEBAPI + 'api/tipo-elemento',
        TABLAS: APPCONFIG.SITE.WEBAPI + 'api/tabla-definicion',
        TIPO_ARRENDAMIENTO: APPCONFIG.SITE.WEBAPI + 'api/tipo-arrendamiento',
        RUBRO: APPCONFIG.SITE.WEBAPI + 'api/rubro',
        RUBRO_ALICUOTA: APPCONFIG.SITE.WEBAPI + 'api/rubro-alicuota',
        ESCRIBANO: APPCONFIG.SITE.WEBAPI + 'api/escribano',
        CATEGORIA_TASA: APPCONFIG.SITE.WEBAPI + 'api/categoria-tasa',
        CATEGORIA_UBICACION: APPCONFIG.SITE.WEBAPI + 'api/categoria-ubicacion',
        CATEGORIA_VEHICULO: APPCONFIG.SITE.WEBAPI + 'api/categoria-vehiculo',
        TIPO_CONTROLADOR: APPCONFIG.SITE.WEBAPI + 'api/tipo-controlador',
        TIPO_CONDICION_ESPECIAL: APPCONFIG.SITE.WEBAPI + 'api/tipo-condicion-especial',
        TIPO_RECARGO_DESCUENTO: APPCONFIG.SITE.WEBAPI + 'api/tipo-recargo-descuento',
        TIPO_MOVIMIENTO: APPCONFIG.SITE.WEBAPI + 'api/tipo-movimiento',
        INCISO_VEHICULO: APPCONFIG.SITE.WEBAPI + 'api/inciso-vehiculo',
        CARTEL_DEFINICION: APPCONFIG.SITE.WEBAPI + 'api/cartel-definicion',
        TIP: APPCONFIG.SITE.WEBAPI_ADMINISTRACION + 'api/tip',
        AUTH_REDIRECT: APPCONFIG.SITE.WEBAPP_PRINCIPAL + 'logout',
    }
}
